import React from "react"
import { FormattedMessage } from "react-intl"
import { Card, CardItem } from "@walmart-web/livingdesign-components"
import { ReactComponent as SearchInfoImage } from "assets/images/search_info.svg"
import "./FiltersDataMessage.styles.scss"
import withVisibility from "../../Hocs/withVisibility"

type FiltersDataMessageProps = {
	title: string
	description: string
	isVisible?: boolean
}

const FiltersDataMessage: React.FC<FiltersDataMessageProps> = (props) => {
	const { title, description } = props
	return (
		<Card>
			<CardItem className="filter-message">
				<span className="filter-message_title">
					<FormattedMessage id={title} />
				</span>
				<p className="filter-message_text">
					<FormattedMessage id={description} />
				</p>
				<div className="filter-message_image">
					<SearchInfoImage />
				</div>
			</CardItem>
		</Card>
	)
}

export default withVisibility(FiltersDataMessage)
